import { tokens, Text, Link, mergeClasses, makeStyles } from "@fluentui/react-components";
import React from "react";

import { Flex, StyledText } from "@tdp/common/fluentV9MigrationComponents";

export interface IAppPageHeader {
  title: string;
  description?: string | React.ReactNode;
  hasSections?: boolean;
  learnMoreLink?: {
    localisedCaption: string;
    href: string;
  };
}

export const useAppPageHeaderStyle = makeStyles({
  contentNoSections: {
    marginBottom: "32px"
  },
  title: {
    marginTop: "0",
    marginBottom: "8px",
    fontSize: "18px",
    fontWeight: "bold",
  },
  description: {
    color: tokens.colorNeutralForeground2
  },
  learnMoreLink: {
    marginLeft: "5px",
    color: tokens.colorBrandForeground2,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  }
});


export const AppPageHeader: React.FC<IAppPageHeader> = (props) => {
  const classes = useAppPageHeaderStyle();

  const renderLearnMoreLink = () => {
    if (props.learnMoreLink) {
      return (
        <>
          <Link href={props.learnMoreLink.href}>
            {props.learnMoreLink.localisedCaption}
          </Link>
        </>
      );
    }
  };

  return (
    <Flex column className={mergeClasses(!props.hasSections && classes.contentNoSections)} >
      <StyledText as="h2" className={classes.title} id="region-details" >{props.title}</StyledText>
      {props.description && (
        <Flex className={classes.description} gap='gap.smaller'>
          {props.description}
          {renderLearnMoreLink()}
        </Flex>
      )
      }
    </Flex >
  );
};
